// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"455aa2a6","355":"2bc0bccf"}[chunkId] + ".chunk.js";
};